import {
  Button,
  EllipsisIcon,
  GripVerticalIcon,
  IconButton,
  InfoIcon,
  PlusIcon,
  SortableList,
} from '@fukuri-admins/ui/common';
import { Menu, MenuItem, Tooltip } from '@mui/material';
import { PortalIcon } from './PortalIcon';
import styles from './styles.module.scss';

type Portal = {
  id: number;
  iconName: React.ComponentProps<typeof PortalIcon>['iconName'];
  title: string;
  linkUrl?: string;
  fileUrl?: string;
  itemType: 'file' | 'url';
  sortOrder: number;
};

type MenuPortal = {
  id: number;
  title: string;
  iconName: React.ComponentProps<typeof PortalIcon>['iconName'];
  linkUrl?: string;
  fileUrl?: string;
  itemType: 'file' | 'url';
  sortOrder: number;
};

type Props = {
  portalItems: Portal[];
  onReOrder: (items: Portal[]) => void;
  popupEl: HTMLElement | null;
  handleOpenPortalMenu: (event: React.MouseEvent<HTMLElement>, portal: MenuPortal) => void;
  handleClosePortalMenu: () => void;
  handleEditPortal: () => void;
  handleDeletePortal: () => void;
  handleOpenCreateModal: () => void;
};

export const PortalListPresentation: React.FC<Props> = ({
  portalItems,
  onReOrder,
  popupEl,
  handleOpenPortalMenu,
  handleClosePortalMenu,
  handleEditPortal,
  handleDeletePortal,
  handleOpenCreateModal,
}) => (
  <div className={styles.container}>
    <div className={styles.container_Header}>
      <div>
        <Button onClick={handleOpenCreateModal} icon={<PlusIcon size='xs' />} iconPosition='left'>
          新規作成
        </Button>
      </div>
    </div>

    <div className={styles.table}>
      <div className={styles.tableHeader}>
        <div className={styles.tableHeaderCell}>
          <span>並び順</span>
          <Tooltip title='ドラッグ操作で並び順を変更できます' placement='top' arrow>
            <span className={styles.infoIcon}>
              <InfoIcon size='xs' />
            </span>
          </Tooltip>
        </div>
        <div className={styles.tableHeaderCell}>アイコン</div>
        <div className={styles.tableHeaderCell}>表示名</div>
        <div className={styles.tableHeaderCell}>リンク先</div>
        <div className={styles.tableHeaderCell}>ファイル</div>
        <div className={styles.tableHeaderCell}>設定</div>
      </div>
      <SortableList
        items={portalItems}
        onReorder={onReOrder}
        renderItem={(row, dragHandleProps) => (
          <div className={styles.tableRow}>
            <div className={styles.tableCell}>
              <div
                className={styles.dragHandle}
                {...dragHandleProps.attributes}
                {...dragHandleProps.listeners}
              >
                <GripVerticalIcon size='xs' />
              </div>
            </div>
            <div className={styles.tableCell}>
              <PortalIcon iconName={row.iconName} />
            </div>
            <div className={styles.tableCell}>
              <span className={styles.tableCellText}>{row.title}</span>
            </div>
            <div className={styles.tableCell}>
              <span className={styles.tableCellText}>{row.linkUrl}</span>
            </div>
            <div className={styles.tableCell}>
              <span className={styles.tableCellText}>{row.fileUrl}</span>
            </div>
            <div className={styles.tableCell}>
              <IconButton
                icon={<EllipsisIcon />}
                aria-label='メニューを開く'
                onClick={e =>
                  handleOpenPortalMenu(e, {
                    id: row.id,
                    title: row.title,
                    iconName: row.iconName,
                    linkUrl: row.linkUrl,
                    fileUrl: row.fileUrl,
                    itemType: row.itemType,
                    sortOrder: row.sortOrder,
                  })
                }
                className={styles.iconButton}
                size='sm'
                variant='ghost'
              />
            </div>
          </div>
        )}
      />
      <Menu
        anchorEl={popupEl}
        open={Boolean(popupEl)}
        onClose={handleClosePortalMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleEditPortal} className={styles.menuItem}>
          編集
        </MenuItem>
        <MenuItem onClick={handleDeletePortal} className={styles.menuItemDelete}>
          削除
        </MenuItem>
      </Menu>
    </div>
  </div>
);
